import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Leaf, LogOut, User as UserIcon, ShieldCheck } from "lucide-react";

export default function Navbar({ onOpenAuth }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const linkClass = ({ isActive }) =>
    `text-sm font-medium tracking-tight transition-colors hover:text-primary ${
      isActive ? "text-primary" : "text-foreground/70"
    }`;

  return (
    <header className="sticky top-0 z-40 border-b border-border/70 backdrop-blur-xl bg-background/75">
      <div className="container-civic flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <span className="relative w-8 h-8 grid place-items-center bg-primary text-primary-foreground rounded-sm">
            <Leaf size={16} strokeWidth={2} />
          </span>
          <span className="font-display text-lg font-extrabold tracking-tight text-foreground">
            fără hârtie<span className="text-[#00D670]">.</span>ro
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8" data-testid="main-nav">
          <NavLink to="/" end className={linkClass} data-testid="nav-home">Acasă</NavLink>
          <NavLink to="/proiecte" className={linkClass} data-testid="nav-projects">Proiecte</NavLink>
          <NavLink to="/despre" className={linkClass} data-testid="nav-about">Despre</NavLink>
          {user && (
            <NavLink to="/dashboard" className={linkClass} data-testid="nav-dashboard">Voturile mele</NavLink>
          )}
          {user?.role === "admin" && (
            <NavLink to="/admin" className={linkClass} data-testid="nav-admin">
              <span className="inline-flex items-center gap-1"><ShieldCheck size={14} /> Admin</span>
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 text-sm">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-7 h-7 rounded-full border border-border" />
                ) : (
                  <span className="w-7 h-7 rounded-full bg-secondary grid place-items-center text-xs font-semibold">
                    {user.name?.[0]?.toUpperCase() ?? <UserIcon size={14} />}
                  </span>
                )}
                <span className="font-medium" data-testid="user-name">{user.name}</span>
              </div>
              <button
                className="btn-secondary !px-3 !py-2"
                onClick={async () => { await logout(); navigate("/"); }}
                data-testid="logout-btn"
              >
                <LogOut size={14} /> Ieșire
              </button>
            </>
          ) : (
            <>
              <button className="btn-secondary !px-4 !py-2" onClick={() => onOpenAuth?.("login")} data-testid="open-login-btn">
                Autentificare
              </button>
              <button className="btn-primary !px-4 !py-2" onClick={() => onOpenAuth?.("register")} data-testid="open-register-btn">
                Cont nou
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
